import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

// Merge conditional + tailwind classes safely (dedupes conflicts).
export const cn = (...inputs) => twMerge(clsx(inputs));
